"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTimezoneTitle = void 0;

var _moment = _interopRequireDefault(require("moment"));

var formatTimezoneTitle = function formatTimezoneTitle(timezone) {
  return "(GMT ".concat((0, _moment.default)().tz(timezone.name).format('Z'), ") ").concat(timezone.title);
};

exports.formatTimezoneTitle = formatTimezoneTitle;